<!--
    @author qixf@thinkerx.com
    @remark 系统管理-报表管理
    @created 2020/5/28
-->
<template>
  <div>
    <!-- 操作按钮 -->
    <div style="margin: 15px 0;">
      <el-button type="danger" icon="el-icon-plus" @click="openDialog()">添加</el-button>
    </div>
    <!-- 表格 -->
    <el-table border stripe :data="list" style="width: 100%;">
      <el-table-column type="index" label="序号" width="60"></el-table-column>
      <!--<el-table-column prop="name" label="名称"></el-table-column>-->
      <el-table-column prop="label" label="标签"></el-table-column>
      <el-table-column label="封面" width="220">
        <template slot-scope="scope">
          <img v-if="scope.row.pic_url" :src="scope.row.pic_url" style="max-width: 150px;max-height: 150px;" />
          <el-button type="text" @click="downloadFile(scope.row.pic_url)">下载</el-button>
        </template>
      </el-table-column>
      <el-table-column label="中文报表" width="150">
        <template slot-scope="scope">
          <span v-if="scope.row.address_zh">已上传
            <el-button type="text" @click="downloadFile(scope.row.address_zh)">下载</el-button>
          </span>
          <span v-else>未上传</span>
        </template>
      </el-table-column>
      <el-table-column label="英文报表" width="150">
        <template slot-scope="scope">
          <span v-if="scope.row.address_en">已上传
            <el-button type="text" @click="downloadFile(scope.row.address_en)">下载</el-button>
          </span>
          <span v-else>未上传</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="200" fixed="right">
        <template slot-scope="scope">
          <el-button type="primary" size="mini" @click="openDialog(scope.row)">编辑</el-button>
          <el-button type="danger" size="mini" @click="deleteReport(scope.row.id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div style="height: 100px;"></div>

    <!-- 添加、编辑报表 弹窗 -->
    <el-dialog :title="report.id?'编辑报表':'添加报表'"
      :visible.sync="open_dialog" width="700px">
      <el-form ref="form" :model="report" :rules="rules" label-width="100px">
        <el-form-item label="分类">
          <el-select v-model="report.type">
            <el-option v-for="item in type_list" :key="item.value"
              :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="排序" prop="sort">
          <el-input v-model.number="report.sort"></el-input>
        </el-form-item>
        <el-form-item label="标签">
          <el-input v-model="report.label"></el-input>
        </el-form-item>
        <el-form-item label="封面">
          <el-upload ref="upload" action="" :http-request="()=>{}"
                     :file-list="file_list.pic_url" list-type="picture"
                     :on-change="(file,fileList)=> { file_list.pic_url = [file] }"
                     :on-remove="(file,fileList)=> { file_list.pic_url = fileList }">
            <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
          </el-upload>
        </el-form-item>
        <el-form-item label="中文报表">
          <el-upload ref="upload" action="" :http-request="()=>{}"
                     :file-list="file_list.address_zh"
                     :on-change="(file,fileList)=> { file_list.address_zh = [file] }"
                     :on-remove="(file,fileList)=> { file_list.address_zh = fileList }">
            <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
          </el-upload>
        </el-form-item>
        <el-form-item label="英文报表">
          <el-upload ref="upload" action="" :http-request="()=>{}"
                     :file-list="file_list.address_en"
                     :on-change="(file,fileList)=> { file_list.address_en = [file] }"
                     :on-remove="(file,fileList)=> { file_list.address_en = fileList }">
            <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
          </el-upload>
        </el-form-item>
        <el-form-item label="打印尺寸">
          <el-input v-model="report.print_size"></el-input>
        </el-form-item>
        <el-form-item label="数据类型">
          <el-radio v-model="report.data_type" :label="1">api</el-radio>
          <el-radio v-model="report.data_type" :label="2">graphql</el-radio>
          <el-radio v-model="report.data_type" :label="3">sessionStorage</el-radio>
        </el-form-item>
        <el-form-item label="api" v-show="report.data_type==1">
          <el-input v-model="report.data_url"></el-input>
        </el-form-item>
        <el-form-item label="查询语句" v-show="report.data_type==2">
          <el-input v-model="report.query_sql" type="textarea" :rows="5"></el-input>
        </el-form-item>
        <el-form-item label="storageKey" v-show="report.data_type==3">
          <el-input v-model="report.query_sql"></el-input>
        </el-form-item>
        <el-form-item label="查询参数" prop="query_need">
          <el-input v-model="report.query_need" type="textarea" :rows="2"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="open_dialog = false">取消</el-button>
        <el-button type="primary" @click="submit" :loading="is_save">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: "report-manager",
  data() {
    var validateJson = (rule, value, callback) => {
      if (value === '') callback();
      else {
        if (typeof value == 'string') {
          try {
            var obj = JSON.parse(value);
            if ( typeof obj == 'object' && obj ){

            }else{
              callback(new Error('请输入正确的JSON格式'));
            }
          } catch(e) {
            callback(new Error('请输入正确的JSON格式'));
          }
        }
        callback();
      }
    };
    return {
      list: [],
      open_dialog: false,
      report: {
        id: '', name: '', label: '', type: "order",
        pic_url: '', address_zh: '', address_en: '',
        data_url: '', query_sql: '', query_need: '{}',
        print_size: '', data_type: 2, sort: 0
      },
      file_list: {
        pic_url: [], address_zh: [], address_en: [],
      },
      rules: {
        sort: [
          { type: 'number', trigger: 'submit', message: '请输入数字' }
        ],
        query_need: [
          { validator: validateJson, trigger: 'submit' }
        ]
      },
      is_save: false,
      type_list: [{ value: "order", label: "合同订单" }, { value: "cut_optimizer", label: "材料优化" }]
    }
  },
  methods: {
    /** 获取列表 **/
    getList() {
      this.$axios.get("reports").then(res => {
        this.list = res.data;
      });
    },
    /** 打开 添加、编辑报表 弹窗 **/
    openDialog(report) {
      this.file_list = { pic_url: [], address_zh: [], address_en: [] };
      if (report) {
        this.report = {
          id: report.id, name: report.name, label: report.label,
          type: report.type,
          pic_url: report.pic_url, address_zh: report.address_zh, address_en: report.address_en,
          data_url: report.data_url, query_sql: report.query_sql, query_need: JSON.stringify(report.query_need),
          print_size: report.print_size, data_type: report.data_type, sort: report.sort
        };
        if (report.pic_url) this.file_list.pic_url = [{ name: "封面", url: report.pic_url }];
        if (report.address_zh) this.file_list.address_zh = [{ name: "中文报表", url: report.address_zh }];
        if (report.address_en) this.file_list.address_en = [{ name: "英文报表", url: report.address_en }];
      }
      else
        this.report = {
          id: '', name: '', label: '', type: "order",
          pic_url: '', address_zh: '', address_en: '',
          data_url: '', query_sql: '', query_need: '{}',
          print_size: '', data_type: 2, sort: this.list.length+1
        };
      this.open_dialog = true;
    },
    /** 提交 **/
    async submit() {
      let is_valid = true;
      this.$refs["form"].validate((valid) => {
        if (!valid) is_valid = false;
      });
      if (!is_valid) return;
      this.is_save = true;
      // 上传文件
      for (let key in this.file_list) {
        if (!this.file_list[key].length) this.report[key] = "";
        else if (this.file_list[key][0].raw)
          this.report[key] = await this.uploadFile(this.file_list[key][0].raw);
      }
      let api = "reports", method = "post";
      if (this.report.id) {
        api += "/"+this.report.id;
        method = "put";
      }
      delete this.report.id;
      // query_need 为空兼容 JSON
      if (!this.report.query_need) this.report.query_need = '{}';
      this.$axios[method](api,this.report).then(res=> {
        this.is_save = false;
        if (!res.code) this.$message.error(res.message);
        else {
          this.getList();
          this.open_dialog = false;
          this.$message.success("保存成功");
        }
      }).catch(err=> {
        this.is_save = false;
        this.$message.error("保存失败");
      })
    },
    /** 上传文件 **/
    uploadFile(file) {
      let form_data = new FormData();
      form_data.append("file",file);
      return this.$axios.post("uploads",form_data).then(res=> {
        if (res.code) return res.data[0];
        else return '';
      })
    },
    /** 删除报表 **/
    deleteReport(id) {
      this.$confirm('确定删除此报表?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.delete(`reports/${id}`).then(res=> {
          if (!res.code) this.$message.error(res.message);
          else {
            this.getList();
            this.$message.success("删除成功");
          }
        }).catch(e=> { this.$message.error("删除失败"); })
      }).catch(() => {});
    },
    /** 下载文件 **/
    downloadFile(url) {
      window.location.href = url;
    }
  },
  mounted() {
    this.getList();
  }
}
</script>
<style lang="scss" scoped>
</style>